import { useState } from "react";

export interface AddressSuggestion {
  place_id: string;
  description: string;
}

export const useAddressSearch = () => {
  const [addressInput, setAddressinput] = useState<string>("");

  return {
    addressInput,
    setAddressinput,
  };
};
